/* eslint-disable */
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, LinearProgress, Paper, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { BsDownload } from 'react-icons/bs';
import { MdArticle, MdFolder, MdSource } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import api, { authHeader } from '../../../../../services/API/apiConfig';
import { Alert } from '../../../../components/singleComponents/alerts/Alert';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';
import { TableFolder } from './TableFolder';

import GlobalContext from '../../../../../context/GlobalContext';
import {
  ContainerFolderNameStyled,
  DefaultPageStyled,
  DivNoDataStyled,
  IconStyled,
  LoadingProgressStyled,
  MobileRootStyled,
  RootStyled,
} from './ConstructionDocuments.styles';

const header = [' ', 'Pasta', 'Data da última modificação'];
const headerDocuments = ['', 'Nome do arquivo', 'Data da última modificação'];
const row = ['name', 'last_modified'];
const rowDocuments = ['name', 'created_at'];

export function ConstructionDocuments() {
  const { id } = useParams();

  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';

  const [construction, setConstruction] = useState([]);

  const [folders, setFolders] = useState([]);
  const [folderShow, setFolderShow] = useState(false);
  const [folderDocuments, setFolderDocuments] = useState([]);
  const [documentShow, setDocumentShow] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState([]);

  const [showToaster, setShowToaster] = useState(false);
  const [toasterMessage, setToasterMessage] = useState('');

  const [permissionsDocuments, setPermissionsDocuments] = useState(true);
  const [loading, setLoading] = useState(true);
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  useEffect(() => {
    const getConstruction = async () => {
      await api
        .get(`/constructions/${id}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setConstruction(data);
        });
    };
    getConstruction();
  }, []);

  async function getFolders() {
    await api
      .get(`constructions/${id}/document-folders`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(true);
        setFolders(data);
        setLoading(false);
      })
      .catch(() => {
        setPermissionsDocuments(false);
        setLoading(false);
      });
  }

  useEffect(() => {
    getFolders();
    setDocumentShow(false);
  }, []);

  async function returnId(idRow) {
    setSelectedFolder(idRow);
    setDocumentShow(true);

    await api
      .get(`/folders/${idRow.id}/documents`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(false);
        setFolderDocuments(data);
      });
  }

  function handleDisplayFile(rowId) {
    window.open(`${protocol}://${subdomain}.${baseURL}${rowId.path.url}`);
  }

  return (
    <>
      {showToaster && <ToasterBox message={toasterMessage} />}
      <Paper>
        {permissionsDocuments ? (
          <>
            {loading ? (
              <LoadingProgressStyled>
                <Typography variant="h2">Carregando...</Typography>
                <LinearProgress style={{ width: '80%' }} />
              </LoadingProgressStyled>
            ) : (
              <>
                {folders.length ? (
                  <>
                    <RootStyled>
                      <ContainerFolderNameStyled>
                        {!folderShow ? (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              disableElevation
                              startIcon={<ArrowBack />}
                              onClick={() => setFolderShow(true)}
                            >
                              Retornar para lista de pastas
                            </Button>
                          </>
                        ) : null}
                      </ContainerFolderNameStyled>
                      {!folderShow ? (
                        <TableFolder
                          data={folderDocuments}
                          headings={headerDocuments}
                          keys={rowDocuments}
                          callbackClickRow={handleDisplayFile}
                        />
                      ) : (
                        <TableFolder
                          data={folders}
                          headings={header}
                          keys={row}
                          callbackClickRow={returnId}
                          editActions
                        />
                      )}
                      {!folders.length && (
                        <DefaultPageStyled>
                          <IconStyled />
                          <Typography>
                            Nenhuma pasta foi adicionada até o momento
                          </Typography>
                        </DefaultPageStyled>
                      )}
                    </RootStyled>
                    <MobileRootStyled>
                      <Typography
                        variant="h2"
                        style={{
                          textAlign: 'center',
                          fontSize: '16px',
                          marginBottom: '28px',
                        }}
                      >
                        Documentos
                      </Typography>
                      {documentShow && (
                        <Typography
                          variant="h2"
                          style={{ textAlign: 'center', color: '#00285A' }}
                        >
                          {selectedFolder.name}
                        </Typography>
                      )}
                      <div className="folderList">
                        {!documentShow
                          ? folders.map((folder) => (
                              <div
                                className="folders"
                                onClick={() => returnId(folder)}
                              >
                                <MdFolder />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <Typography variant="body2">
                                    {folder.name}
                                  </Typography>
                                  <Typography variant="body2">
                                    Modificada em{' '}
                                    {new Intl.DateTimeFormat('pt-BR').format(
                                      new Date(folder.last_modified)
                                    )}
                                  </Typography>
                                </div>
                              </div>
                            ))
                          : folderDocuments.map((documents) => (
                              <div className="documents" key={documents.id}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                  }}
                                >
                                  <MdArticle />
                                  <div>
                                    <Typography variant="body2">
                                      {documents.name}
                                    </Typography>
                                    <Typography variant="body2">
                                      Adicionada em {documents.created_at}
                                    </Typography>
                                  </div>
                                </div>
                                <BsDownload
                                  className="downloadIcon"
                                  onClick={() => handleDisplayFile(documents)}
                                />
                              </div>
                            ))}
                      </div>
                    </MobileRootStyled>
                  </>
                ) : (
                  <DivNoDataStyled>
                    <MdSource size={200} color="#B9B9B9" />
                    <Typography variant="body1" style={{ color: '#1c1c1ccc' }}>
                      Nenhum documento adicionado até o momento.
                    </Typography>
                  </DivNoDataStyled>
                )}
              </>
            )}
          </>
        ) : (
          <Alert alertTitle="Documentos indisponível" />
        )}
      </Paper>
    </>
  );
}
